export default {
  appIcon: 'kustomer-app-icon',
  appIconImage: 'kustomer-app-icon-image',
  appMinimizedUnreadIcon: 'kustomer-app-minimized-unread-icon',
  appEmailBannerSuccesssContainer: 'kustomer-app-email-banner-success-container',
  appEmailBannerSuccesssMessage: 'kustomer-app-email-banner-success-message',
};
